<template>
  <div
    class="planning-modal-option"
    :class="option.value"
    :value="option.value"
  >
    <div class="option-label">
      {{ option.label }}
    </div>

    <div class="option-visualizer">
      <!-- TODO: Put a visualizer here for the selected ship orders -->
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { DropdownOption } from '@rygen/rygen-ui/model';

import { RoutePlanType, ValidShipOrder } from '@/model/routeBuilder';

const props = defineProps({
  option: {
    type: Object as PropType<DropdownOption<RoutePlanType>>,
    required: true,
  },
  shipOrders: {
    type: Array as PropType<ValidShipOrder[]>,
    default: () => [],
  },
});
const { option } = toRefs(props);
</script>

<style>
.planning-modal-option {
  display: flex;
  gap: var(--gap-1);
  cursor: pointer;
  width: 100%;

  .option-label {
    flex: 1 0 33%;
    padding: var(--sp-6);
  }

  .option-visualizer {
    flex: 1 0 66%;
  }
}
</style>
